import { VisibilityState } from '@tanstack/react-table'
import { Atom } from 'jotai'
import {
  allTableRowsAtom,
  contextualTableRowsAtom,
  elementTableRowsAtom,
  hazardTableRowsAtom,
} from '../state/data-submodule.atoms'
import { DataModuleRow, DataTabKey } from '../types'

/**
 * Returns the default column visibility configuration for a given data tab.
 */
export const getDefaultColumnVisibility = (tab: DataTabKey): VisibilityState => {
  switch (tab) {
    case 'hazards':
      return {
        category: true,
        group: false,
        owner: false,
        confidenceRating: false,
        lastUpdated: false,
        unit: false,
      }

    case 'contextual':
      return { category: true, owner: false, lastUpdated: false, unit: false, group: false }

    case 'elements':
      return { category: true, owner: false }

    case 'all':
    default:
      return { category: true, owner: false, group: false }
  }
}

/**
 * Maps each DataTabKey to its corresponding Jotai Atom containing a promise of DataModuleRow array.
 */
export const tabAtomMap = {
  all: allTableRowsAtom,
  elements: elementTableRowsAtom,
  hazards: hazardTableRowsAtom,
  contextual: contextualTableRowsAtom,
  reference: allTableRowsAtom,
} satisfies Record<DataTabKey, Atom<Promise<DataModuleRow[]>>>

/**
 * Groups hazard rows by hazard_name (single level).
 * Sorted by scenario count descending (largest groups first),
 * with missing hazardName bucketed as "Other" at the end.
 */
export const groupByHazardName = (rows: DataModuleRow[]): Map<string, DataModuleRow[]> => {
  const result = new Map<string, DataModuleRow[]>()

  for (const row of rows) {
    const key = row.hazardName ?? 'Other'
    const bucket = result.get(key) ?? []
    bucket.push(row)
    result.set(key, bucket)
  }

  return new Map(
    [...result.entries()].sort(([a, aRows], [b, bRows]) => {
      if (a === 'Other') return 1
      if (b === 'Other') return -1
      return bRows.length - aRows.length
    }),
  )
}
